import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import { AuthProvider } from './lib/auth';
import { applyTheme, storedTheme } from './lib/theme';
import './styles.css';

/*
 * Applied before the first render, not from an effect inside the shell. An
 * effect runs after paint, so the admin would open in dark and flip to light a
 * frame later for anybody who chose light — and the login screen, which is
 * outside the shell, would never flip at all.
 */
applyTheme(storedTheme());

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, refetchOnWindowFocus: false } },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
);
